// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ToDoCardFragmentDoc } from '../../../components/to-dos/ToDosBoard.generated';
import { ToDoModal_ToDoChecklistItemFragmentDoc } from '../../../components/to-dos/ToDoModal.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ToDosPdfQueryVariables = Types.Exact<{
  filter: Types.ToDoFilter;
}>;


export type ToDosPdfQuery = { __typename?: 'Query', toDos: Array<{ __typename?: 'ToDo', id: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, description?: string | null | undefined, order: string, urgent: boolean, checklistItems: Array<{ __typename?: 'ToDoChecklistItem', id: string, description: string, isComplete: boolean }>, status: { __typename?: 'ToDoStatusDetail', name: string, code: Types.ToDoStatus, sortOrder: number }, type: { __typename?: 'ToDoTypeDetail', name: string, code: Types.ToDoType }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl: string, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }>, parent?:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Cohort', id: string, name: string }
      | { __typename?: 'Development', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     | null | undefined, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number }>, followers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, checklistProgress: { __typename?: 'ToDoChecklistProgress', total: number, completed: number } }> };

export type ToDoPdfFragment = { __typename?: 'ToDo', id: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, name: string, description?: string | null | undefined, order: string, urgent: boolean, checklistItems: Array<{ __typename?: 'ToDoChecklistItem', id: string, description: string, isComplete: boolean }>, status: { __typename?: 'ToDoStatusDetail', name: string, code: Types.ToDoStatus, sortOrder: number }, type: { __typename?: 'ToDoTypeDetail', name: string, code: Types.ToDoType }, assignees: Array<{ __typename?: 'User', id: string, name: string, avatarUrl: string, internalUser?: { __typename?: 'InternalUser', id: string } | null | undefined }>, parent?:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Cohort', id: string, name: string }
    | { __typename?: 'Development', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   | null | undefined, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number }>, followers: Array<{ __typename?: 'InternalUser', id: string, name: string }>, checklistProgress: { __typename?: 'ToDoChecklistProgress', total: number, completed: number } };

export const ToDoPdfFragmentDoc = gql`
    fragment ToDoPdf on ToDo {
  ...ToDoCard
  checklistItems {
    ...ToDoModal_ToDoChecklistItem
  }
}
    ${ToDoCardFragmentDoc}
${ToDoModal_ToDoChecklistItemFragmentDoc}`;
export const ToDosPdfDocument = gql`
    query ToDosPdf($filter: ToDoFilter!) {
  toDos(filter: $filter) {
    ...ToDoPdf
  }
}
    ${ToDoPdfFragmentDoc}`;

/**
 * __useToDosPdfQuery__
 *
 * To run a query within a React component, call `useToDosPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useToDosPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToDosPdfQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useToDosPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ToDosPdfQuery, ToDosPdfQueryVariables> & ({ variables: ToDosPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ToDosPdfQuery, ToDosPdfQueryVariables>(ToDosPdfDocument, options);
      }
export function useToDosPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ToDosPdfQuery, ToDosPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ToDosPdfQuery, ToDosPdfQueryVariables>(ToDosPdfDocument, options);
        }
// @ts-ignore
export function useToDosPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ToDosPdfQuery, ToDosPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDosPdfQuery, ToDosPdfQueryVariables>;
export function useToDosPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDosPdfQuery, ToDosPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ToDosPdfQuery | undefined, ToDosPdfQueryVariables>;
export function useToDosPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ToDosPdfQuery, ToDosPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ToDosPdfQuery, ToDosPdfQueryVariables>(ToDosPdfDocument, options);
        }
export type ToDosPdfQueryHookResult = ReturnType<typeof useToDosPdfQuery>;
export type ToDosPdfLazyQueryHookResult = ReturnType<typeof useToDosPdfLazyQuery>;
export type ToDosPdfSuspenseQueryHookResult = ReturnType<typeof useToDosPdfSuspenseQuery>;
export type ToDosPdfQueryResult = Apollo.QueryResult<ToDosPdfQuery, ToDosPdfQueryVariables>;